import React, { useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Form } from 'antd'
import { Button } from 'react-bootstrap'

import { FormContainer, NumberInput, ToggleSwitch, NumberInputWithSlider } from 'Shared/Components/FormComponents'
import { showSuccess } from 'Shared/Components/NotifyToast'
import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import RoiDrawModal from '../RoiDrawModal'

const AIDangerZone = ({ camera_id, toggle }) => {
  const { t } = useTranslation()
  const { send } = useFetchData()
  const [form] = Form.useForm()
  const { setPageLoading } = useOutletContext()

  const [roi, setRoi] = useState({
    "area": null,
    "snapshot": null
  })

  const [moduleNotFound, setModuleNotFound] = useState(false)
  const [roiModalOpen, setRoiModalOpen] = useState(false)

  const loadConfig = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/ai_detection/configuration/danger_zone/${camera_id}`,
      returnType: "json"
    })

    if (body == null) {
      setModuleNotFound(true)
      return
    }

    form.setFieldsValue({
      "detection_enabled": body["enabled"],
      "recording_duration": body["recording_duration"],
      "cool_down_time": body["cool_down_time"],
      "push_alert": body["push_alert"]
    })

    setRoi({
      "area": body["roi"],
      "snapshot": null
    })
  }

  useEffect(() => {
    setPageLoading(true)

    const init = async () => {
      await Promise.all([
        loadConfig()
      ])

      setPageLoading(false)
    }

    init()
  }, [])

  const onFinish = async (values) => {
    setPageLoading(true)

    const res = await send({
      method: "PUT",
      url: `${apiUrl}/ai_detection/configuration/danger_zone/${camera_id}`,
      contentType: "json",
      body: {
        "enabled": values["detection_enabled"],
        "recording_duration": values["recording_duration"],
        "cool_down_time": values["cool_down_time"],
        "push_alert": values["push_alert"],
        "roi": roi["area"]
      }
    })

    if (res != null) {
      showSuccess(t("general_success"))
      toggle()
    }

    setPageLoading(false)
  }

  const detection_enabled = Form.useWatch('detection_enabled', { form, preserve: true })

  return (<>
    {moduleNotFound ? (
      <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div><b>Module not found</b></div>
      </div>
    ) : (<>
      <FormContainer form={form} onFinish={onFinish} initialValues={{}}>
        <ToggleSwitch field_id="detection_enabled" field_name="Detection Enabled"/>  

        {detection_enabled && <>
          <NumberInput field_id="recording_duration" field_name="Recording Duration (Seconds)" required props={{ "min": 3, "max": 10 }}/>

          <NumberInput field_id="cool_down_time" field_name="Cool Down Time (Seconds)" required props={{ "min": 5, "max": 300 }}/>

          <ToggleSwitch field_id="push_alert" field_name="Push Alert Enabled"/>  

          <Form.Item>
            <Button onClick={() => setRoiModalOpen(true)}>
              {t("Redraw ROI")}
            </Button>
          </Form.Item>
        </>}
      </FormContainer>

      {roiModalOpen && 
        <RoiDrawModal camera_id={camera_id} toggle={() => setRoiModalOpen()} roi={roi["area"]} onRoiChange={(value) => setRoi(value)}/>
      }
    </>)}
  </>)
}

export default AIDangerZone
